export default "Optimisez vos achats d'énergie dans le cadre des marchés publics. Courtier référencé UGAP, compatible CCAG-PI, toutes les offres comparées.";

